import { render } from "./we_project.vue?vue&type=template&id=5ee8b93e&scoped=true"
const script = {}

import "./we_project.vue?vue&type=style&index=0&id=5ee8b93e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ee8b93e"]])

export default __exports__